import { rootStore } from 'stores';
import StoreContext from 'stores/context/StoreContext';

const StoreProvider = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
);

export default StoreProvider;
